import { Box, Typography } from '@material-ui/core';
import PopoverWrap from 'components/@common/Popover';
import React from 'react';
import SubText from './SubText';

type Props = {
  title: string;
  helperText?: string;
  headerList: Array<{
    title: string;
    subTitle: string;
    subTitleValue: string | number;
    helpText?: string;
  }>;
};

const AssessmentStatusDetails: React.FC<Props> = ({ headerList, title, helperText = '' }) => {
  return (
    <>
      <Typography variant="h4" style={{ marginBottom: 32 }}>
        {title === '*' ? '' : title}
      </Typography>
      <Box display="flex" width="70%" justifyContent="space-between" marginBottom={4}>
        {headerList.map((x, idx) => (
          <Box key={`status_details_${idx}`}>
            <PopoverWrap description={x.helpText}>
              <Typography>{x.title}</Typography>
            </PopoverWrap>
            <Typography variant="h1">
              {x.subTitleValue} <SubText>{x.subTitle}</SubText>
            </Typography>
          </Box>
        ))}
      </Box>
    </>
  );
};

export default AssessmentStatusDetails;
